module.exports = __webpack_public_path__ + "static/media/perfect-gold_00009.52e85e46.png";